import React, { createContext, useContext, useState, useCallback, useEffect } from 'react'
import HttpModule from 'src/shared/http'
import { getToken } from '../shared/localStoreage'

const StatementContext = createContext({})

const StatementProvider = ({ children }) => {
  const [statement, setStatement] = useState(0)
  const [loading, setLoading] = useState(false)
  const [initialized, setInitialized] = useState(false)

  const fetchStatement = useCallback(async () => {
    const token = getToken()
    if (!token) {
      return
    }

    try {
      setLoading(true)
      const httpModule = new HttpModule()
      httpModule.setResource('/credit-balance')
      const response = await httpModule.get()
      const balance = response?.data?.balance || 0
      setStatement(balance)
      setInitialized(true)
      return balance
    } catch (error) {
      console.error('Erro ao buscar saldo:', error)
      setInitialized(true)
      throw error
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    if (!initialized) {
      fetchStatement()
    }
  }, [initialized, fetchStatement])

  return (
    <StatementContext.Provider value={{ statement, setStatement, fetchStatement, loading }}>
      {children}
    </StatementContext.Provider>
  )
}

const useStatement = () => {
  const context = useContext(StatementContext)
  if (!context) {
    throw new Error('useStatement must be used within an StatementProvider')
  }
  return context
}

export { StatementProvider, useStatement }
